import { Form } from "antd";
import i18n from "i18next";
import { useParams } from "react-router";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { SiteIdCopyGenerator } from "./SiteIdCopyGenerator";

export const SiteIdCopyGeneratorField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    const { id } = useParams();

    return (
        <Form.Item noStyle shouldUpdate={() => true}>
            {id && (
                <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules}>
                    <SiteIdCopyGenerator
                        key={field.name}
                        readOnly={readOnly}
                        siteId={id}
                        label={i18n.t(field.translationKeys.label)}
                        name={field.name}
                    />
                </Form.Item>
            )}
        </Form.Item>
    );
};
